/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { quarterComparator } from '../../../../../SharedModules/DateUtilities/DateUtilities';
import { sortComparator } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
// import CheckBoxRender from "./checkBoxRender";

export const tableHead = [
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator: quarterComparator,
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 8,
      custWidth: '135px',
    },
    cellStyle: {
      'padding-bottom': 5,
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Quarter',
    field: 'endQtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator: quarterComparator,
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 8,
      custWidth: '135px',
    },
    cellStyle: {
      'padding-bottom': 5,
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Spec Thera Code',
    field: 'specTheraClassCd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator: (valueA, valueB) =>
      sortComparator(valueA.trim().toUpperCase(), valueB.trim().toUpperCase()),
    cellRenderer: 'TextBoxRender',
    cellEditorParams: {
      maxLength: 8,
      custWidth: '135px',
    },
    resizable: false,
    cellStyle: {
      'padding-bottom': 5,
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
